import { makeAutoObservable } from 'mobx';

class ViewStore {
    isHeaderSticky = false;

    constructor(model) {
        this.model = model;
        makeAutoObservable(this, {
            model: false
        });
    }

    setHeaderSticky = (value) => {
        this.isHeaderSticky = value;
    }
}

export default ViewStore;
